import React from 'react';
import {Task} from 'entities/task';
import {OrderActionDrawers, useOrderActions} from 'features/order-actions';
import {ActionMenu, Button} from 'ui';
import {OrderActionCellIcon} from './OrderActionCellIcon';

interface OrderActionCellProps {
	task: Task;
}

export function OrderActionCell({task}: OrderActionCellProps): React.ReactElement | null {
	const {actions, signAcceptance, createReceipt, declineDrawer, employmentMismatch} = useOrderActions(task, 'table');
	if (!actions.length) return null;

	if (actions.length === 1) {
		const action = actions[0];

		return (
			<>
				<Button
					type="button"
					className="flex items-center gap-2 justify-between px-2 py-1 min-w-[141px] float-end"
					onClick={action.onSelect}
					disabled={action.disabled}
				>
					{action.label}
					<span aria-hidden="true">
						<OrderActionCellIcon />
					</span>
				</Button>
				<OrderActionDrawers
					task={task}
					signAcceptance={signAcceptance}
					createReceipt={createReceipt}
					declineDrawer={declineDrawer}
					employmentMismatch={employmentMismatch}
				/>
			</>
		);
	}

	return (
		<>
			<div className="float-end">
				<ActionMenu
					items={actions.map((a) => ({
						key: a.id,
						label: a.label,
						onSelect: a.onSelect,
						disabled: a.disabled,
					}))}
					triggerLabel="Действия"
				/>
			</div>
			<OrderActionDrawers
				task={task}
				signAcceptance={signAcceptance}
				createReceipt={createReceipt}
				declineDrawer={declineDrawer}
				employmentMismatch={employmentMismatch}
			/>
		</>
	);
}
